const form = {
  formId: "new-user-form",
  formField: {
    taxpayers: {
      name: "taxpayers",
      label: "Người nộp thuế:",
      type: "text",
      placeholder: "Người nộp thuế",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxCode: {
      name: "taxCode",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "Mã số thuế",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Đại lý thuế",
      errorMsg: "Vui lòng nhập tên đại lý thuế",
    },
    taxAgentCode: {
      name: "taxAgentCode",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "Mã số thuế",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    ///
    BCTC: {
      name: "BCTC",
      label: "BCTC đã được kiểm toán",
      type: "text",
    },
    supportData: {
      name: "supportData",
      label: "Hỗ trợ lấy dữ liệu từ năm trước",
      type: "text",
    },
    enterVoiceover: {
      name: "enterVoiceover",
      label: "Tích chọn để nhập cột thuyết minh",
      type: "text",
    },
    auditOpinion: {
      name: "auditOpinion",
      label: "Ý kiến kiểm toán:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn ý kiến kiểm toán",
    },
    ///
    chartMaker: {
      name: "chartMaker",
      label: "Người lập biểu:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người lập biểu",
    },
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Kế toán trưởng:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên kế toán trưởng",
    },
    certificateNumber: {
      name: "certificateNumber",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số chứng chỉ hành nghề",
    },
    accountingService: {
      name: "accountingService",
      label: "Đơn vị cung cấp dịch vụ kế toán:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên đơn vị cung cấp dịch vụ kế toán",
    },
    unitHeads: {
      name: "unitHeads",
      label: "Thủ trưởng đơn vị:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên thủ trưởng đơn vị",
    },
    dateFounded: {
      name: "dateFounded",
      label: "Ngày lập:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày lập",
    },
  },
};

export default form;
